import { useCallback } from 'react';

import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import Page from '@sayyesschool/frontend/components/page';
import { useCourses } from '@sayyesschool/frontend/features/courses';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import CourseForm from '../course-form';
import CoursesTable from '../courses-table';

export default function CoursesPage() {
    const [courses, actions] = useCourses();
    const [isFormDialogOpen, toggleFormDialogOpen] = useBoolean(false);

    const handleSubmit = useCallback(data => {
        return actions.createCourse(data)
            .then(() => toggleFormDialogOpen(false));
    }, [actions, toggleFormDialogOpen]);

    if (!courses) return <LoadingIndicator fullscreen />;

    return (
        <Page className="CoursesPage">
            <Page.Header
                title="Курсы"
                actions={[
                    {
                        key: 'add',
                        content: 'Создать курс',
                        icon: 'add',
                        variant: 'solid',
                        onClick: toggleFormDialogOpen
                    }
                ]}
            />

            <Page.Content>
                <Page.Section compact>
                    <CoursesTable courses={courses} />
                </Page.Section>
            </Page.Content>

            <FormDialog
                title="Новый курс"
                open={isFormDialogOpen}
                onClose={toggleFormDialogOpen}
            >
                <CourseForm
                    id="course-form"
                    onSubmit={handleSubmit}
                />
            </FormDialog>
        </Page>
    );
}